var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-listagem" },
    [
      _c(
        "el-row",
        [
          _vm.modalVincular
            ? _c("VincularProcesso", {
                attrs: {
                  nomeDocumento: _vm.nomeDocumento,
                  tipoDocumento: _vm.tipoDocumento
                },
                on: { closeModal: _vm.closeModalVincular, incluir: _vm.incluir }
              })
            : _vm._e(),
          _c(
            "el-col",
            [
              _c(
                "Pesquisa",
                {
                  attrs: {
                    placeHolder:
                      "Informe o nome do documento, responsável ou tipo do documento",
                    cardStyle: {
                      margin: "0px 0px 10px 0px",
                      "border-radius": "12px"
                    },
                    hasPesquisaAvancada: true
                  },
                  on: {
                    search: _vm.handlePesquisa,
                    resetSearch: _vm.resetPesquisa,
                    searchAdvanced: _vm.pesquisarAvancado,
                    changeTipoPesquisa: _vm.changeTipoPesquisa
                  }
                },
                [
                  _c(
                    "template",
                    { slot: "pesquisaAvancada" },
                    [
                      _c("pesquisa-avancada-documentos-assinados", {
                        attrs: { filtro: _vm.pesquisaAvancada }
                      })
                    ],
                    1
                  )
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "default-card", attrs: { shadow: "hover" } },
        [
          _c("app-divider-refresh-button", {
            attrs: {
              label: "Listagem de Documentos",
              hasButton: true,
              content: "Atualizar documentos"
            },
            on: { click: _vm.resetPesquisa }
          }),
          _c(
            "el-table",
            {
              ref: "table",
              staticClass: "table",
              attrs: { data: _vm.documentosAssinados },
              on: { "sort-change": _vm.sortChanged }
            },
            [
              _c("template", { slot: "empty" }, [_vm._v("Não há registros.")]),
              _c("el-table-column", {
                attrs: {
                  prop: "nome",
                  label: "Nome do documento",
                  width: "auto",
                  sortable: "custom",
                  formatter: _vm.Utils.formatEmptyRow
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop:
                    "assinadores.responsavel.usuario.pessoa.pessoaFisica.nome",
                  label: "Responsável(eis)",
                  formatter: _vm.Utils.formatEmptyRow,
                  width: "auto",
                  sortable: "custom"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("list-responsavel-assinatura", {
                          attrs: {
                            assinadores: scope.row.assinadores,
                            showIcon: false
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "assinadores.dataAssinatura",
                  label: "Datas de assinatura",
                  width: "auto",
                  sortable: "custom",
                  formatter: _vm.formatDate
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return _vm._l(scope.row.assinadores, function(assinador) {
                        return _c("div", { staticClass: "item-list" }, [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.formatDataAssinatura(
                                  assinador.dataAssinatura
                                )
                              )
                            )
                          ])
                        ])
                      })
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "tipo.nome",
                  label: "Documento",
                  formatter: _vm.Utils.formatEmptyRow,
                  width: "auto",
                  sortable: "custom"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "numeroProcesso",
                  label: "Processo vinculado",
                  formatter: _vm.Utils.formatEmptyRow,
                  width: "auto",
                  sortable: "custom"
                }
              }),
              _c("el-table-column", {
                attrs: { label: "Ações", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("button-acoes", {
                          attrs: { acoes: _vm.botoesAcao(scope.row) }
                        })
                      ]
                    }
                  }
                ])
              })
            ],
            2
          ),
          _c("app-paginacao", {
            attrs: { total: _vm.totalCadastros, pagina: _vm.pagina },
            on: { changePage: _vm.changePage }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-025332bf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-025332bf","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/assinatura/ListagemDocumentosAssinados.vue
// module id = null
// module chunks = 